import { MemberSettingAuthMode, MemberSettingFundingMode, MemberSettingNameMode } from "kz-ui-sdk";
import { Currency, CurrencyDirection } from "./configs";

/**
 * TODO: Move to kz-ui-sdk when BE confirmed
 * Place with _ prefix to mark will be removed
 */
export enum _MemberSettingOnboardDialogLayout {
  // Popup dialog with onboarding drawer
  DIALOG_DRAWER = "dialog-drawer",
  // Popup dialog with onboarding screen
  DIALOG_PAGE = "dialog-page",
}

/**
 * Member settings:
 * MP use member settings to configure the app UI/UX
 * UI/UX can be configured from server:
 */
export interface MemberSettings {
  /**
   * Determines the theme of the app
   * /info.theme.color
   */
  themeId: string;
  /**
   * Determines the phone prefix of the app
   * /info.phoneSpec.phonePrefix
   */
  phonePrefix: string;
  /**
   * Determines the phone length of the app
   * /info.phoneSpec.length
   */
  phoneLength: number;
  /**
   * Determines the currency of the app
   * /info.currency
   */
  currency: Currency | string;
  /**
   * Determines the currency direction of the app
   * Direction from {@link CURRENCY_CONFIGS}
   */
  currencyDirection: CurrencyDirection;
  /**
   * Determines the currency symbol of the app
   * Symbol from {@link CURRENCY_CONFIGS}
   */
  currencySymbol: string;
  /**
   * Determines the language of the app
   * /info.languageCode
   */
  language: string;
  /**
   * Determines the language list of the app
   * /info.languageList
   */
  languageList: string[];
  /**
   * @deprecated Use feature flags instead
   * /info.countryCode
   */
  countryCode: string;
  // feature flags
  authMode: MemberSettingAuthMode | null;
  fundingMode: MemberSettingFundingMode | null;
  nameMode: MemberSettingNameMode | null;
  onboardDialogLayout: _MemberSettingOnboardDialogLayout;
  /**
   * Determines if the member settings are loaded
   * Should only render app after member settings are loaded
   */
  isLoaded: boolean;
}

/**
 * Theme portal config
 * These configs are used to configure the theme in MP only
 * Whereas ThemeColorConfig is used to configure the theme in SDK
 *
 */
export interface ThemePortalConfig {
  metaThemeColor: string;
  extendedCss: string;
  className: string;
  id: string;
}

export enum PostLoginInfoType {
  BANK_ACCOUNT = "bankAccount",
  LEGAL_NAME = "legalName",
}
